export default __webpack_public_path__ + "static/media/breastfeeding-uncropped.a01cffbf.png";